import traceActionsCreator from '../traceActionsCreator'

export const createInquiryServiceName = 'Global/createInquiry'
export const createInquiryTraceActions = traceActionsCreator(
  createInquiryServiceName
)
